import React, { useState } from 'react';
import { Typography, Layout, Space, Card, Row, Col, Spin } from 'antd';
import PageTitle from 'shared_components/page_title';
import SearchPager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

import SearchForm from "./payment_searchForm";
import SearchTable from "./payment_searchTable";

import '../payments.css'

const {Content} = Layout;

function Search() {
    const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
    const [searchLoading, setSearchLoading] = useState(false);
    const [data, setData] = useState([]);

    function search(payload) {
        setData(payload);
    }

    function handleSearchStart() {
        setSearchLoading(true);
    }

    function handleSearchEnd() {
        setSearchLoading(false);
    }

    const handleChangeSize = (pageSize) => {
        setPageSize(pageSize);
    }

    return (
        <div>
            <Card>
            <PageTitle pageTitle="PAYMENT" />
                {/* <Row gutter={[8,1]} align="bottom">
                    <Col span={24}> */}
                    <SearchForm onFinish={ search } onSearchStart={handleSearchStart} onSearchEnd={handleSearchEnd} />
                    <SearchPager 
                        pageTotal={data.length === null ? 0 : data.length}
                        pageSize={pageSize}
                        handleChangeSize={handleChangeSize}
                    />
                    <Spin spinning={searchLoading} tip="Searching...">
                        <SearchTable data={data} pageSize={pageSize} />
                    </Spin>
                    {/* </Col>                    
                </Row> */}
            </Card>
        </div>
    );
}

export default Search;